import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { catchError, combineLatest, map, Observable, throwError } from 'rxjs';
import { DetailedTdRate, TdRate, TdRateToAdd, TdRateToUpdate } from './td-rate.model';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TdRatesService {
  private apiEndpoint = `${environment.apiEndpoint}/api/td-rates`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  public getTdRates$(date: Date, currency: string): Observable<TdRate[]> {
    return this.http
      .get<TdRate[]>(this.apiEndpoint, {
        params: {
          date: moment(date).format('YYYY-MM-DD'),
          currency: currency
        }
      })
      .pipe(
        catchError((error: any) => {
          this.logger.error(error);
          return throwError(() => error);
        })
      );
  }

  public getTdRate$(id: number): Observable<DetailedTdRate> {
    return this.http.get<DetailedTdRate>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public insertTdRate$(tdRate: TdRateToAdd): Observable<DetailedTdRate> {
    return this.http.post<DetailedTdRate>(this.apiEndpoint, tdRate).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public insertManyTdRates$(tdRates: TdRateToAdd[]): Observable<void> {
    return this.http.post<void>(`${this.apiEndpoint}/bulk`, tdRates).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public updateTdRate$(id: number, TdRate: TdRateToUpdate): Observable<DetailedTdRate> {
    return this.http.put<DetailedTdRate>(`${this.apiEndpoint}/${id}`, TdRate).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteTdRate$(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteMultipleTdRates$(ids: number[]): Observable<void> {
    return combineLatest(ids.map((id) => this.deleteTdRate$(id))).pipe(map(() => {}));
  }

  public getBulkTdRatesFileTemplate$(): Observable<Blob> {
    return this.http.get(`${this.apiEndpoint}/bulk/template`, { responseType: 'blob' }).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public uploadBulkTdRatesFileAndInsertTdRates$(bulkTdRatesFileTempPath: string): Observable<number> {
    return this.http.post<number>(`${this.apiEndpoint}/bulk/upload`, { bulkTdRatesFileTempPath }).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }
}
